module.exports = __webpack_public_path__ + "264db9858a059d52f5aaba728a8f8fee.svg";